export const cmsApis = {
  financeApi: '/v1/F2044',   //获取财经日历数据
  newsListApi: '/v1/F203',   //获取新闻列表
  fastListApi: '/v1/F203',   //获取市场快讯列表
  hotNewsApi:'/v1/F208',     //热点新闻
  hotNewaDetailApi:'/v1/F209',//热点新闻详情
  noticeListApi:'/v1/s1607',//公告列表
  noticeDetailApi:'/v1/s1608',//公告详情
  dataCenterApi: '/api/MTDataBase/GetRealTimeOrderListForPm',//数据中心
  positionRatioApi:'/api/MTDataBase/GetGoldSilverCommandPosForPm',//持仓比例
  allPositionsApi:'/api/MTDataBase/GetGoldSilverCommandPosForPm',//全部开仓
  positionRatioACancelApi:'/api/MTDataBase/GetGoldSilverPosForPm',// 未平仓品种比率
  GetAccTradeInfo:'/api/MTDataBase/GetAccTradeInfo',//订单查询(平仓单查询，持仓单查询，平仓单和持仓单总查询)
  // --------------------抽奖相关------------------
  drawApi:'/userlotteryinfo/lottery',//抽奖
  searchTurntable:'/turntable/findall',//查询转盘
  drawNumberApi:'/turntablenumstatus/selectlotteryinfo',//抽奖次数
  drawHistory:'/turntablelog/findall',//抽奖记录
  //转盘活动区域
  
  // -----------------------答题相关----------------
  selectperiodid:'/answeractivityaccounttopic/selectperiodid',//期数
  findbyansweractivityid:'/answeractivityconfigperiodtopic/findbyansweractivityid',//答题活动
  accountanswer:'/answeractivityaccounttopic/accountanswer',//答案
  answeractivityid:'/answeractivityaccounttopic/findbyaccountidandansweractivityid',//答题列表
  findall:'/answeractivityaccountaward/findall',//答题活动奖励
  findbyaccountid: '/activityuserinfo/findbyaccountid',//查询用户信息
  paidUrl: 'findall',
  firstJoinActivityInfo: '/firstadvamt/usercenter',   //查询用户参与首充活动信息
  fileUpload:'',//上传文件

  // --------------------好友助力相关------------------
  friendusercenter:'/usercenter',//用户中心
  isactivity: '/ongoing',// 是否有进行中的活动
  isinvited: '/isinvited',// 是否被邀请
  friendassistRegister:'/register',//好友助力注册
  rewardDetail: '/myprize',//奖励详情
  // --------------------交易保障计划相关------------------
  protectnewtrade:'protectnewtrade/register',//报名
  getlevels:'protectnewtrade/getlevels',//查询等级组
  userChangelevel:'protectnewtrade/userChangelevel',//调档
}

